export const GOZO_SLEEPING = true
